import vue from 'vue';

const SET_BOOKING = (state, booking) => {
  state.booking = booking;
};

const SET_OFFERS = (state, payload) => {
  state.offers = payload.map(offer => ({ ...offer, ...offer['location'] }));
};

const SET_OFFER = (state, offer) => {
  state.selectedOffer = offer;
};

const SET_LATEST_VERSION = (state, res) => {
  vue.set(state.booking, 'searchConfig', res.searchConfig);
  vue.set(state.booking, 'latest', res.latest);
  vue.set(state.booking, 'bookingServices', res.bookingServices);
};

const SET_PART_QUALITY_TYPE_LIST = (state, payload) => {
  state.partQualityTypes = payload;
};

const SET_GUILD_LIST = (state, payload) => {
  state.guilds = payload;
};

const SET_OFFER_SEARCH = (state, payload) => {
  state.offersearch = payload;
};

const SET_SERVICES = (state, payload) => {
  state.services = payload;
};

const SET_ADDITIONAL_SERVICES = (state, payload) => {
  state.additionalServices = payload;
};

export default {
  SET_BOOKING,
  SET_OFFERS,
  SET_LATEST_VERSION,
  SET_PART_QUALITY_TYPE_LIST,
  SET_GUILD_LIST,
  SET_OFFER,
  SET_OFFER_SEARCH,
  SET_ADDITIONAL_SERVICES,
  SET_SERVICES
}
